module.exports = __webpack_public_path__ + "static/media/esoko.87f3f5b3.svg";